import '#admin/bootstrap';

class Admin {
    init = () => {};
}

export default Admin;
